import { render, staticRenderFns } from "./goods-config.vue?vue&type=template&id=4f5a1779&scoped=true"
import script from "./goods-config.vue?vue&type=script&lang=js"
export * from "./goods-config.vue?vue&type=script&lang=js"
import style0 from "./goods-config.vue?vue&type=style&index=0&id=4f5a1779&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5a1779",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f5a1779')) {
      api.createRecord('4f5a1779', component.options)
    } else {
      api.reload('4f5a1779', component.options)
    }
    module.hot.accept("./goods-config.vue?vue&type=template&id=4f5a1779&scoped=true", function () {
      api.rerender('4f5a1779', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modulestore/common/goods-config.vue"
export default component.exports